<template>
  <div>
    <div class="w-full h-full fixed left-0 top-0 bg-white bg-opacity-50 z-50" v-if="isLoading">
      <loader :label="$t('frontend_loading')" />
    </div>
    <portal to="headerContent">
      <div class="flex items-center">
        <div class="cursor-pointer" @click="showSidebar = !showSidebar">
          <GeneralIcon class="h-6 w-6 text-black" />
        </div>
        <gd-button size="auto" class="ml-4 text-dark" @click="updatePost(2)" v-if="post.status === 2 && publishClicked">{{
          $t('frontend_save_draft') }}</gd-button>
        <gd-button size="auto" class="ml-4 text-dark" @click="updatePost(2)" v-if="post.status != 2">{{
          $t('frontend_grooveblog_switch_to_draft') }}</gd-button>
        <gd-button size="auto" class="ml-4 text-dark" @click="previewPost">{{ $t('frontend_preview') }}</gd-button>
        <!-- <gd-button
          size="auto"
          class="ml-4 text-dark"
          @click="markdownPreview"
          >{{ $t('frontend_grooveblog_markdown_preview') }}</gd-button
        > -->
        <gd-button size="auto" class="px-10 h-10 ml-2" @click="updatePost(1)" variant="primary" v-if="showPublish">{{
          $t('frontend_publish') }}</gd-button>
        <gd-button size="auto" class="px-10 h-10 ml-2" @click="updatePost(3)" variant="primary" v-if="showSchedule">{{
          $t('frontend_schedule') }}</gd-button>
      </div>
      <gd-modal name="confirm-modal" :title="$t('frontend_grooveblog_your_changes_will_be_lost')">
        <div class="flex flex-col px-8 py-5">
          <div class="flex flex-col w-full mb-4">
            {{ $t('frontend_grooveblog_exit_changes') }}
          </div>
          <div class="flex flex-row w-full mt-4 justify-center">
            <gd-button class="text-center h-10 border-grey-1" size="large" variant="outline" @click="sendToPost">{{
              $t('frontend_grooveblog_exit_without_save_changes')
            }}</gd-button>
            <gd-button class="text-center h-10 ml-4" size="large" variant="primary" @click="saveConfirm">{{
              $t('frontend_save') }}</gd-button>
          </div>
        </div>
      </gd-modal>
    </portal>
    <portal to="headerBreadCrumb">
      <div class="flex h-full items-center cursor-pointer" @click="showConfirmModal">
        <i class="fas fa-chevron-left" style="font-size: 20px; color: #d4d5e5"></i>
      </div>
    </portal>
    <create-category-modal ref="createCategoryModal" :blog-id="blogId" @setIsLoading="isLoading = $event"
      @getCategory="getCategory($event)" />
    <!-- <gd-modal
      ref="markdownPreviewModal"
      name="markdownPreviewModal"
      title="Markdown Preview"
      width="75%"
      height="100%"
    >
      <div style="overflow-y: scroll !important" class="ml-6 mt-4 ql-editor markdown-text" v-html="markdownPreviewHtml" />
    </gd-modal> -->
    <div id="scrolling-container" class="flex bg-white justify-center overflow-y-auto" style="height: calc(100vh - 65px)">
      <div class="pt-5 pb-10" style="width: 700px">
        <div class="post-title" :placeholder="$t('frontend_enter_title')" contenteditable="true" @input="getTitle">
          {{ postTitle }}
        </div>
        <div class="w-full error text-primary-dark mt-1 text-base" v-if="titleRequired">
          {{ $t('frontend_grooveblog_post_required_title') }}
        </div>
        <div class="relative">
          <div id="sidebar-controls" class="flex insert-image-menu" v-bind:style="{ top: topPosition + 'px' }"
            v-if="showToolbar">
            <button id="show-controls" class="btn-toggle" @click="showButtons = !showButtons">
              <i class="fa fa-plus"></i>
            </button>
            <div class="controls flex" v-if="showButtons">
              <div class="relative img-picker">
                <image-picker v-model="postImage" :primary="true" @change="imgUpload"></image-picker>
                <div class="btn-toggle">
                  <i class="far fa-images"></i>
                </div>
              </div>
              <div class="relative video-picker">
                <video-picker class="absolute left-0 top-0" :value="{ videoSrc: '', videoEmbed: '' }"
                  @selected="videoUpload"></video-picker>
                <button class="btn-toggle">
                  <i class="fa fa-film"></i>
                </button>
              </div>
              <button class="btn-toggle" @click="createEmbedModal">
                <i class="fa fa-code"></i>
              </button>
            </div>
          </div>
          <quill-editor v-model="post.description" :options="editorOptions" class="swipesEditor w-full"
            @ready="onEditorReady($event)" @change="onEditorChange($event)" @focus="onEditorFocus($event)">
          </quill-editor>
          <gd-modal ref="embedModal" name="embed-code-modal" :title="$t('frontend_add_embed_html')">
            <div class="flex flex-col px-8 py-5">
              <div class="flex flex-col w-full mb-4">
                <text-area class="w-full" v-model="embedCode"></text-area>
              </div>

              <div class="flex flex-row w-full mt-4 justify-center">
                <gd-button class="text-center h-10 border-grey-1" size="large" @click="closeEmbedModal">{{
                  $t('frontend_cancel') }}</gd-button>
                <gd-button class="text-center h-10 ml-4" size="large" variant="primary" @click="saveEmbedCode">{{
                  $t('frontend_done') }}</gd-button>
              </div>
            </div>
          </gd-modal>
        </div>
      </div>
      <transition name="slide">
        <div class="bg-secondary-darker text-white absolute right-0" style="width: 320px" v-if="showSidebar">
          <div class="
              heading
              border-solid border-secondary-light border-b
              flex flex-row
              justify-between
            ">
            <div class="flex flex-column items-center h-16">
              <span class="px-4 cursor-pointer" @click="showSidebar = false">
                <close-icon class="" />
              </span>
              <span>{{ $t('frontend_grooveblog_post_settings') }}</span>
            </div>
          </div>

          <div class="overflow-y-auto custom-scrollbars p-4 post-setting text-sm"
            style="max-height: calc(100vh - 133px); height: 100vh">
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-2 flex">{{
                $t('frontend_grooveblog_featured_image')
              }}</label>
              <image-picker class="post-image" v-model="post.post_image" :primary="true"></image-picker>
            </div>
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-2 flex">Post Slug</label>
              <text-input class="" variant="dark" placeholder="" v-model="post.slug" />
            </div>
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-1 flex">{{
                $t('frontend_grooveblog_view_page')
              }}</label>
              <div class="text-sm permalink break-all">
                <a :href="permalinkUrl" target="_blank" :class="{ disabled: !permalinkSlugUrl }">{{ permalinkUrl }}</a>
              </div>
            </div>
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-2 flex">{{
                $t('frontend_grooveblog_publish_date')
              }}</label>
              <div class="w-full">
                <date-time-picker v-model="dateTime" variant="dark" class="" @input="checkDate" />
              </div>
              <div class="text-primary mt-3 cursor-pointer" v-if="this.showSchedule" @click="resetDate">
                <i class="fas fa-redo-alt" style="width: 10px"></i>
                {{ $t('frontend_reset') }}
              </div>
            </div>
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-2 flex">{{
                $t('frontend_grooveblog_categories')
              }}</label>
              <multi-select v-model="selectedCategories" :options="allCategories" variant="dark" trackBy="id" label="name"
                :placeholder="$t('frontend_categories')">
              </multi-select>
              <div class="text-primary mt-3 cursor-pointer" @click="createCategoryModal">
                + {{ $t('frontend_grooveblog_add_new_category') }}
              </div>
              <span class="text-red" v-if="categoryRequired">This field is required</span>
            </div>
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-2 flex">{{
                $t('frontend_grooveblog_keywords')
              }}</label>
              <vue-tags-input v-model="tag" :tags="post.tags" :placeholder="$t('frontend_grooveblog_add_tags')"
                :autocomplete-items="filteredItems" @tags-changed="(newTags) => (post.tags = newTags)" />
              <div class="text-xs text-grey-100 mt-2 flex">
                {{ $t('frontend_grooveblog_keywords_separeteby_enter') }}
              </div>
            </div>
            <div class="mb-6">
              <label class="text-sm text-grey-100 mb-2 flex">{{
                $t('frontend_grooveblog_excerpt')
              }}</label>
              <text-area class="" variant="dark" v-model="post.excerpt" :validator="$v.post.excerpt"></text-area>
            </div>
            <div class="mb-6">
              <div class="flex items-center mb-4">

                <gd-checkbox v-model="post.popular_post" variant="primary" class="float-left"
                  :label="$t('frontend_grooveblog_general_popular_posts')"
                  labelClass="text-secondary-invert font-bold text-sm" />
              </div>
              <div class="flex items-center mb-4">
                <gd-checkbox v-model="post.show_sidebar" variant="primary" class="float-left"
                  :label="$t('frontend_grooveblog_show-sidebar')" labelClass="text-secondary-invert font-bold text-sm" />
              </div>
              <div class="flex items-center mb-4">
                <gd-checkbox v-model="post.add_carousel" variant="primary" class="float-left"
                  :label="$t('frontend_grooveblog_add_to_carousel')"
                  labelClass="text-secondary-invert font-bold text-sm" />
              </div>
              <div class="flex items-center mb-4">
                <gd-checkbox v-model="post.show_homepage" variant="primary" class="float-left"
                  :label="$t('frontend_grooveblog_show_on_homepage')"
                  labelClass="text-secondary-invert font-bold text-sm" />
              </div>
              <div class="flex items-center mb-4">
                <gd-checkbox v-model="post.show_comments" variant="primary" class="float-left"
                  :label="$t('frontend_grooveblog_allow_comments')"
                  labelClass="text-secondary-invert font-bold text-sm" />
              </div>

              <!-- Post indexing toggle -->
              <div class="flex items-center">
                <label class="text-sm text-grey-100 mr-1">{{
                  $t('frontend_grooveblog_disable_post_indexing')
                }}</label>
                <InfoIcon class="mr-4 cursor-pointer" v-tooltip="{
                      classes: 'w-96 grooveblog-tooltip',
                      content: this.$t('frontend_grooveblog_disable_post_indexing_info'),
                    }" />
                <gd-toggle v-model="post.disable_indexing" bgClass="bg-secondary"></gd-toggle>
              </div>
            </div>
            <div class="meta-data mb-4">
              <div class="mb-2 rounded-md bg-secondary-light">
                <div class="
                    flex
                    justify-between
                    items-center
                    font-bold
                    text-base
                    p-4
                  " @click="show_metadata = !show_metadata" :class="{ active: show_metadata }">
                  <span>{{ $t('frontend_grooveblog_edit_metadata') }}</span>
                  <i class="fas fa-chevron-right text-2xl" style="color: #a3a3bf"></i>
                </div>
                <div class="p-4 pt-0" v-if="show_metadata">
                  <text-input class="mb-3" variant="dark" :placeholder="$t('frontend_enter_meta_title')"
                    v-model="post.meta_data.title" />
                  <text-area class="mb-3 border-white" variant="dark" :placeholder="$t('frontend_enter_meta_description')"
                    v-model="post.meta_data.description"></text-area>
                  <text-area class="" variant="dark" :placeholder="$t('frontend_enter_meta_keywords')"
                    v-model="post.meta_data.keyword"></text-area>
                </div>
              </div>
              <div class="mb-2 rounded-md bg-secondary-light">
                <div class="
                    flex
                    justify-between
                    items-center
                    font-bold
                    text-base
                    p-4
                  " @click="show_opengraph = !show_opengraph" :class="{ active: show_opengraph }">
                  <span>{{ $t('frontend_grooveblog_edit_og') }}</span>
                  <i class="fas fa-chevron-right text-2xl" style="color: #a3a3bf"></i>
                </div>
                <div class="p-4 pt-0" v-if="show_opengraph">
                  <text-input class="mb-3" variant="dark" :placeholder="$t('frontend_enter_og_title')"
                    v-model="post.open_graph.title" />
                  <text-input class="mb-3" variant="dark" :placeholder="$t('frontend_enter_og_url')"
                    v-model="post.open_graph.url" />
                  <gd-dropdown :options="openGraphTypeList" class="w-full  mb-3" variant="dark"
                    v-model="post.open_graph.type" :placeholder="$t('frontend_enter_og_type')"></gd-dropdown>
                  <text-area class="mb-3" variant="dark" :placeholder="$t('frontend_enter_og_description')"
                    v-model="post.open_graph.description"></text-area>
                  <div class="mb-6">
                    <label class="text-sm text-grey-100 mb-2 flex">{{
                      $t('frontend_grooveblog_og_image')
                    }}</label>
                    <image-picker class="post-image" v-model="post.open_graph.image" :primary="true"></image-picker>
                  </div>
                </div>
              </div>
              <div class="mb-2 rounded-md bg-secondary-light">
                <div class="
                    flex
                    justify-between
                    items-center
                    font-bold
                    text-base
                    p-4
                  " @click="show_customcode = !show_customcode" :class="{ active: show_customcode }">
                  <span>{{ $t('frontend_grooveblog_add_custom_code') }}</span>
                  <i class="fas fa-chevron-right text-2xl" style="color: #a3a3bf"></i>
                </div>
                <div class="p-4 pt-0 text-area" v-if="show_customcode">
                  <div
                    class=" w-full border border-solid rounded-lg border-secondary-lighter mb-2 bg-secondary-lighter p-3 text-white">
                    Please note: In order to embed some code to the post
                    sidebar, please add the code with proper tags for script and
                    CSS
                  </div>
                  <text-area class="w-full" variant="dark" :placeholder="$t('frontend_enter_custom_code')"
                    v-model="post.custom_code"></text-area>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- success banner for publish, save, draft, schedule -->
    <gd-banner v-if="publishSuccess || saveSuccess || draftSuccess || scheduleSuccess" :text="publishSuccess ? $t('frontend_grooveblog_post_publish_in_progress')
      : saveSuccess ? $t('frontend_grooveblog_post_has_been_saved')
        : draftSuccess ? $t('frontend_grooveblog_post_reverted_to_draft')
          : $t('frontend_grooveblog_post_has_been_scheduled')" variant="success" :showIcon="true"
      position="bottom-left" />
    <!-- danger banner for category -->
    <gd-banner v-if="categoryRequired"
      :text="$t('frontend_the_post_needs_category_to_be_selected_in_order_to_save_and_publish')" variant="danger"
      :showIcon="true" position="bottom-right" />
    <div class="hidden-elements">
      <video-picker class="absolute left-0 bottom-0" ref="videoPicker" :value="{ videoSrc: '', videoEmbed: '' }"
        @selected="videoEdit"></video-picker>
      <gd-modal ref="addAlt" name="addAlt" width="50%" height="50%" :title="$t('frontend_grooveblog_editor_add_alt')"
        @closed="closeAddAlt">
        <div class="m-6">
          <label class="text-sm text-grey-700 mb-2 flex">{{ $t('frontend_grooveblog_editor_image_alt') }}</label>
          <text-input class="input-text" :placeholder="$t('frontend_grooveblog_editor_image_alt_text')"
            v-model="imageAlt" />
          <gd-button class="m-2" variant="primary" @click="saveAlt">{{ $t('frontend_save') }}</gd-button>
        </div>
      </gd-modal>
      <gd-modal ref="editImageModal" name="editImageModal" width="100%" height="100%">
        <image-picker-without-modal :value="postImage" modal="true" remove="false"
          @close-modal="$refs.editImageModal.close()" @selected="editImage"></image-picker-without-modal>
      </gd-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ImagePickerWithoutModal from '@groovepages/gd-ui-kit/components/ImagePicker';
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';
import VideoPicker from '@groovepages/gd-ui-kit/components/video-library/VideoLibrary';
import GdCheckbox from '@groovepages/gd-ui-kit/components/Checkbox';
import 'vue2-timepicker/dist/VueTimepicker.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  maxLength,
  requiredIf,
} from 'vuelidate/lib/validators';
import Loader from '@groovepages/gd-ui-kit/components/Loader';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import VueTagsInput from '@johmun/vue-tags-input';
import DateTimePicker from '@groovepages/gd-ui-kit/components/DateTimePicker';
import moment from 'moment-timezone';
import shortId from 'shortid';
import themeConfig from '@/theme/themeConfig.js';
import GeneralIcon from '@/assets/images/icons/config.svg';
import InfoIcon from '@/assets/images/icons/info-icon.svg';
import CloseIcon from '@/assets/images/icons/close.svg';
import '@/assets/scss/tooltip.scss';
import '@/helpers/blotEmbed.js';
import '@/helpers/blotVideo.js';
import '@/helpers/blotImage.js';
import { quillToolbar, vueQuillInit, theBlockBlot } from './custom-editor.js';
import CreateCategoryModal from './create-category-modal';

const EMBED_CODE_MODAL = 'embed-code-modal';
const MODAL_CLOSE = 'modal-close';

export default {
  middleware: 'auth',
  layout: 'defaultWithoutSidebarLogo',
  data() {
    return {
      postUrl: '', postTitle: '', postImage: '',
      postVideo: '', quillData: '', tag: '',
      youtubeUrl: 'https://www.youtube.com/embed/',
      vimeoUrl: 'https://player.vimeo.com/video/',
      grooveVideoUrl: 'https://app.groove.cm/groovevideo/video',
      showButtons: false, showToolbar: false, show_metadata: false, show_opengraph: false,
      show_customcode: false, showSidebar: true, showPublish: true, showSchedule: false,
      topPosition: '',
      categoryRequired: false,
      seoToken: false,
      editorOptions: {
        modules: { toolbar: quillToolbar },
        theme: 'bubble',
        scrollingContainer: '#scrolling-container',
        placeholder: this.$t('frontend_groovevideo_video_create_enter_description'),
      },
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      blogId: '',
      date: '', time: '',
      dateTime: moment().toISOString(),
      allCategories: [],
      selectedCategories: [],
      disabledDates: { to: new Date(Date.now() - 8640000) },
      post: {},
      autocompleteItems: [],
      publishSuccess: false,
      scheduleSuccess: false,
      saveSuccess: false,
      draftSuccess: false,
      publishClicked: true,
      previewUrl: '',
      embedCode: '',
      embedEdit: false,
      titleRequired: false,
      permalinkUrl: '',
      permalinkSlugUrl: '',
      treeselectKey: 0,
      changeInPage: 0,
      openGraphTypeList: ['blog', 'article', 'author', 'book', 'game', 'movie', 'food', 'recipe', 'company', 'hotel', 'restaurant'],
      takeScreenshot: false,
      markdownPreviewHtml: '',
      imageAlt: '',
    };
  },
  components: {
    quillEditor,
    ImagePicker,
    ImagePickerWithoutModal,
    VideoPicker,
    Loader,
    VueTagsInput,
    DateTimePicker,
    GdCheckbox,
    CreateCategoryModal,
    InfoIcon,
    GeneralIcon,
    CloseIcon,
  },
  validations: {
    post: {
      excerpt: {
        maxLength: maxLength(200),
      },
    },
    selectedCategories: {
      required: requiredIf(() => {
        return true;
      }),
    },
  },

  async mounted() {
    this.blogId = localStorage.getItem('blog-id');
    this.post.blog_id = this.blogId;
    await this.checkToken();
    await this.getCategory(this.blogId);
    await this.getTags(this.blogId);
    await this.getPost();
    await this.getBlog();
    await this.checkCategory(this.selectedCategories);
    await this.getPostSidebar(this.blogId);
    this.$nextTick(() => {
      this.takeScreenshot = false;
    });
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
    computedPost() {
      return { ...this.post };
    },
  },
  watch: {
    post: {
      deep: true,
      handler() {
        this.changeInPage += 1;
      },
    },
    dateTime() {
      this.setScreenshot();
    },
    selectedCategories() {
      this.setScreenshot();
    },

    computedPost: {
      deep: true,
      handler(newVal, oldVal) {
        this.checkScreenshot(newVal, oldVal);
        if (
          oldVal.title === newVal.meta_data.title ||
          newVal.title === newVal.meta_data.title
        ) {
          this.post.meta_data.title = this.post.title;
        }
        if (
          oldVal.excerpt === newVal.meta_data.description ||
          newVal.excerpt === newVal.meta_data.description
        ) {
          this.post.meta_data.description = this.post.excerpt;
        }
        if (
          oldVal.title === newVal.open_graph.title ||
          newVal.title === newVal.open_graph.title
        ) {
          this.post.open_graph.title = this.post.title;
        }
        if (
          oldVal.excerpt === newVal.open_graph.description ||
          newVal.excerpt === newVal.open_graph.description
        ) {
          this.post.open_graph.description = this.post.excerpt;
        }
      },
    },
  },
  methods: {
    setScreenshot() {
      if (!this.takeScreenshot) {
        this.takeScreenshot = true;
      }
    },
    checkScreenshot(newVal, oldVal) {
      if(!this.takeScreenshot && (
          oldVal.popular_post !== newVal.popular_post ||
          oldVal.add_carousel !== newVal.add_carousel ||
          oldVal.show_homepage !== newVal.show_homepage ||
          oldVal.title !== newVal.title ||
          oldVal.excerpt !== newVal.excerpt ||
          oldVal.post_image !== newVal.post_image)
      ) {
        this.takeScreenshot = true;
      }
    },
    editImage(filename) {
      if (typeof filename === 'string') {
        const range = this.quillData.getSelection(true);
        const randomId = shortId.generate();

        this.quillData.deleteText(range.index, 1);
        this.quillData.insertEmbed(range.index, 'imageElement', {
          value: filename,
          alt: '',
          shortId: randomId
        }
        );
        this.quillData.setSelection(range.index, true);
      }
    },
    openAltModal(alt) {
      this.imageAlt = alt;
      this.$refs.addAlt.open();
    },
    saveAlt() {
      const range = this.quillData.getSelection(true);
      const content = this.quillData.getContents(range.index, 1);

      this.quillData.deleteText(range.index, 1);
      this.quillData.insertEmbed(range.index, 'imageElement', {
        value: content.ops[0].insert.imageElement.value,
        alt: this.imageAlt,
        shortId: content.ops[0].insert.imageElement.shortId
      });
      this.quillData.setSelection(range.index, true);

      this.$refs.addAlt.close();
      this.imageAlt = '';
    },
    closeAddAlt() {
      this.imageAlt = '';
    },

    getTitle(e) {
      this.post.title = e.target.innerText.trim();
      if (this.post.title) {
        this.titleRequired = false;
      } else {
        this.titleRequired = true;
      }
    },
    async getTags(blogId) {
      this.showLoader();
      await axios
        .get(`/tags?blog_id=${blogId}`)
        .then((response) => {
          this.autocompleteItems = response.data.data;
          for (let i = 0; i < this.autocompleteItems.length; i += 1) {
            this.autocompleteItems[i].text = this.autocompleteItems[i].name;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    onEditorReady(quill) {
      this.quillData = quill;
      vueQuillInit(quill);
    },
    onEditorChange({ quill }) {
      return theBlockBlot(quill, this);
    },
    onEditorFocus(quill) {
      return theBlockBlot(quill, this);
    },
    imgUpload(filename) {
      if (typeof filename === 'string') {
        this.closeAddItemToolbar();
        const randomId = shortId.generate();
        const range = this.quillData.getSelection(true);
        this.quillData.insertEmbed(range.index, 'imageElement', {
          value: this.postImage,
          alt: '',
          shortId: randomId
        }
        );
        this.quillData.setSelection(range.index, true);
      }
    },

    videoUpload(video) {
      this.closeAddItemToolbar();
      if (!video.video_embed) return;

      const randomId = shortId.generate();
      const range = this.quillData.getSelection(true);

      this.quillData.insertEmbed(range.index, 'addVideo', {
        videoSrc: video.video_source,
        videoEmbed: video.video_embed,
        shortId: randomId,
      });

      this.quillData.setSelection(range.index, true);
      this.currentElement = '';
    },
    videoEdit(video) {
      if (!video.video_embed) return;
      const randomId = shortId.generate();
      const range = this.quillData.getSelection(true);

      this.quillData.deleteText(range.index, 1);
      this.quillData.insertEmbed(range.index, 'addVideo', {
        videoSrc: video.video_source,
        videoEmbed: video.video_embed,
        shortId: randomId,
      });
      this.quillData.setSelection(range.index, true);
    },
    createEmbedModal() {
      this.$root.$emit('modal-open', EMBED_CODE_MODAL);
    },
    closeEmbedModal() {
      this.$root.$emit(MODAL_CLOSE, EMBED_CODE_MODAL);
      this.closeAddItemToolbar();
      this.embedEdit = false;
    },
    saveEmbedCode() {
      this.showLoader();
      const randomId = shortId.generate();
      const range = this.quillData.getSelection(true);
      if (this.embedEdit) {
        this.embedEdit = false;
        this.quillData.deleteText(range.index, 1);
      }
      this.quillData.insertEmbed(range.index, 'embedElement', {
        value: this.embedCode,
        shortId: randomId,
      });

      this.quillData.setSelection(range.index + 1, true);
      this.closeAddItemToolbar();
      setTimeout(() => {
        this.hideLoader();
        this.$root.$emit(MODAL_CLOSE, EMBED_CODE_MODAL);
        this.embedCode = '';
      }, 3000);
    },
    async getPost() {
      this.showLoader();
      await axios.get(`/blog-posts/${this.$route.params.postId}`)
        .then((response) => {
          this.post = response.data;
          this.postUrl = this.post.url;
          this.post.excerpt = this.post.excerpt?.substring(0, 200) || '';
          this.post.meta_data = this.post.meta_data || { title: '', description: '', keyword: '' };
          this.post.open_graph = this.post.open_graph || { title: '', url: '', type: 'blog', description: '', image: '' };
          this.post.slug = this.post.slug || '';
          this.post.open_graph.url = this.post.open_graph.url || '';

          if (this.post?.open_graph?.type) {
            this.openGraphTypeList.push(this.post.open_graph.type);
          }

          this.dateTime = moment(this.post.date_and_time).toISOString();
          this.checkDate(this.dateTime);
          this.post.description = this.post.description?.replaceAll('\n', '<br>') || '';
          this.postTitle = this.post.title;

          this.permalinkSlugUrl = this.post.status === 1 ? this.permalinkUrl + this.post.slug : '';

          for (let i = 0; i < this.post.categories.length; i += 1) {
            this.selectedCategories.push(this.post.categories[i]);
          }

          for (let i = 0; i < this.post.tags.length; i += 1) {
            this.post.tags[i].text = this.post.tags[i].name;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.iframeScrolling();
      this.hideLoader();
    },
    getCategory(blogId) {
      axios
        .get(`/categories?blog_id=${blogId}`)
        .then((response) => {
          this.allCategories = response.data;
          for (let i = 0; i < this.allCategories.length; i += 1) {
            this.allCategories[i].label = this.allCategories[i].name;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async updatePost(status) {
      this.$v.post.$touch();

      if (!this.seoToken && this.selectedCategories.length <= 0) {
        this.categoryRequired = true;
        setTimeout(() => {
          this.categoryRequired = false;
        }, 2000);
      } else if (!this.$v.post.$invalid && this.post.title) {
        this.$v.post.$reset();
        this.showLoader();
        // if (status === 1) {
        //   this.dateTime = moment().toISOString();
        // }
        const guess = moment.tz.guess();
        this.post.date_and_time = moment(this.dateTime).tz(guess).format();
        this.post.schedule_time = moment(this.dateTime).toISOString();
        this.post.slug = this.post.slug
          .replace(/[^A-Z0-9/_]+/gi, '-')
          .replace(/^-+/, '') // trim - from start of text
          .replace(/-+$/, '') // trim - from end of text
          .toLowerCase();
        this.post.open_graph.url = this.post.open_graph.url
          .replace(/[^A-Z0-9/_]+/gi, '-')
          .toLowerCase();
        if (status === 1) {
          this.permalinkSlugUrl = this.permalinkUrl + this.post.slug;
        } else {
          this.permalinkSlugUrl = '';
        }
        this.takeScreenshot = (status !== 2 && this.takeScreenshot) || this.post.status !== status;
        this.post.status = status;
        this.post.category_id = this.selectedCategories.map((item) => item.id);
        await axios
          .put(`/blog-posts/${this.$route.params.postId}`, {
            title: this.post.title,
            blog_id: this.blogId,
            category_id: this.post.category_id,
            tags: this.post.tags,
            description: this.post.description,
            slug: this.post.slug,
            post_image: this.post.post_image,
            date_and_time: this.post.date_and_time,
            schedule_time: this.post.schedule_time,
            excerpt: this.post.excerpt,
            add_carousel: this.post.add_carousel,
            show_sidebar: this.post.show_sidebar,
            show_homepage: this.post.show_homepage,
            show_comments: this.post.show_comments,
            disable_indexing: this.post.disable_indexing,
            popular_post: this.post.popular_post,
            status: this.post.status,
            meta_data: this.post.meta_data,
            open_graph: this.post.open_graph,
            custom_code: this.post.custom_code,
            take_screenshot: this.takeScreenshot
          })
          .then(() => {
            this.hideLoader();
            if (status === 1) {
              this.publishClicked = false;
              this.publishSuccess = true;
              this.postTitle = this.post.title;
              setTimeout(() => {
                this.publishSuccess = false;
              }, 10000);
            } else if (status === 3) {
              this.publishClicked = false;
              this.scheduleSuccess = true;
              setTimeout(() => {
                this.scheduleSuccess = false;
              }, 2000);
            } else if (status === 2 && !this.publishClicked) {
              this.publishClicked = true;
              this.publishSuccess = false;
              this.draftSuccess = true;
              setTimeout(() => {
                this.draftSuccess = false;
              }, 2000);
            } else {
              this.saveSuccess = true;
              setTimeout(() => {
                this.saveSuccess = false;
              }, 2000);
            }
            this.takeScreenshot = false;
            this.changeInPage = 1;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.titleRequired = true;
      }
    },
    showConfirmModal() {
      if (this.changeInPage > 1) {
        this.$root.$emit('modal-open', 'confirm-modal');
      } else {
        this.sendToPost();
      }
    },
    closeAddItemToolbar() {
      this.showButtons = false;
      this.showToolbar = false;
    },
    sendToPost() {
      this.$router.push({ name: 'list_post' });
    },
    async saveConfirm() {
      if (this.post.status === 2 && this.publishClicked) {
        await this.updatePost(2);
      } else if (this.showPublish) {
        await this.updatePost(1);
      } else if (this.showSchedule) {
        await this.updatePost(3);
      }
      this.sendToPost();
    },
    async previewPost() {
      this.showLoader();
      if (this.post.status === 2 && this.publishClicked) {
        await this.updatePost(2);
      } else if (this.showPublish) {
        await this.updatePost(1);
      } else {
        await this.updatePost(3);
      }
      await axios
        .get(`/blogs/${this.blogId}`)
        .then((response) => {
          const blogData = response.data.data;
          this.previewUrl = `${blogData.published_url}/post_preview.html?id=${this.post.id}`;
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
      window.open(this.previewUrl, '_blank');
    },

    async getMarkdownText() {
      this.showLoader();
      try {
        const markdownwHTML = await axios.post(
          'blogpost/markdown',
          {
            text: this.post.description,
          }
        );

        this.markdownPreviewHtml = markdownwHTML.data.data;
      } catch (error) {
        console.error(error);
      }
      this.hideLoader();
    },

    async markdownPreview() {
      await this.getMarkdownText();
      this.$refs.markdownPreviewModal.open();
    },

    createCategoryModal() {
      this.$refs.createCategoryModal.open();
    },
    checkDate(selectDate) {
      const now = moment().toISOString();
      const date = moment(selectDate).toISOString();
      if (date) {
        if (now > date) {
          this.showSchedule = false;
          this.showPublish = true;
        } else {
          this.showSchedule = true;
          this.showPublish = false;
        }
      }
    },
    async getPostSidebar(blogId) {
      if (this.post.show_sidebar == null) {
        await axios
          .get(`/themes/${blogId}`)
          .then((response) => {
            console.log('show_sidebar:', this.post.show_sidebar);
            const themeSettings = response.data.data;
            this.post.show_sidebar =
              themeSettings.layout_setting.postPage.sidebar;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    resetDate() {
      this.dateTime = moment().toISOString();
      this.showSchedule = false;
      this.showPublish = true;
    },
    iframeScrolling() {
      const getIframe = document.getElementsByClassName('ql-video');
      for (let i = 0; i < getIframe.length; i += 1) {
        getIframe[i].setAttribute('scrolling', 'no');
      }
    },
    getBlog() {
      this.showLoader();
      axios
        .get(`/blogs/${this.blogId}`)
        .then((response) => {
          const publishedUrl = response.data.data.published_url;
          const blogSeoUrl = this.postUrl;
          this.permalinkUrl = `${publishedUrl}/${blogSeoUrl}/`;
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkCategory(value) {
      this.showLoader();

      axios.get(`/seo-category-validate/${this.blogId}/2`)
        .then((response) => {
          if (!response.data.available) {
            const currentSelectedIndex = this.allCategories.findIndex(
              (x) => x.id === value[0]
            );
            if (currentSelectedIndex >= 0) {
              for (let i = 0; i < this.allCategories.length; i += 1) {
                this.allCategories[i].isDisabled = true;
              }
              this.allCategories[currentSelectedIndex].isDisabled = false;
            } else {
              for (let i = 0; i < this.allCategories.length; i += 1) {
                this.allCategories[i].isDisabled = false;
              }
            }
            this.treeselectKey += 1;
          }
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkToken() {
      axios.get(`/seo-category-validate/${this.blogId}/2`).then((response) => {
        this.seoToken = response.data.available;
      });
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style>
.ql-tooltip {
  min-width: auto;
}

.ql-toolbar-embed svg {
  fill: #fff;
}

.ql-toolbar-embed svg:hover {
  fill: var(--brand-primary);
}

.custom-ql-image {
  margin-top: 20px;
  margin-bottom: 20px;
}

.hidden-elements .video-iframe-edit>.cursor-pointer>svg {
  display: none;
}
</style>
